/**
 * Firebase configuration and initialization
 * Centralized Firebase setup for the application
 */

import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import logger from './logger';

const firebaseConfig = {
  apiKey: "AIzaSyCuT7ZskFnqgJv_S4N006NDGq1CZAInm6w",
  authDomain: "stream-clipperz.firebaseapp.com",
  projectId: "stream-clipperz",
  storageBucket: "stream-clipperz.firebasestorage.app",
  messagingSenderId: "794140635987",
  appId: "1:794140635987:web:91402fd78746762966a7a6",
  measurementId: "G-XTFDMWBVZS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check
const isLocalhost = typeof window !== 'undefined' && (
  window.location.hostname === 'localhost' || 
  window.location.hostname === '127.0.0.1'
);
const isProduction = process.env.NODE_ENV === 'production';

if (typeof window !== 'undefined') {
  if (isLocalhost) {
    // App Check will automatically use debug mode on localhost
    try {
      const _appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider('6LcBAkcrAAAAAIQ69nUdnV96Aqq9y3Pjhg3oCl8i'),
        isTokenAutoRefreshEnabled: true
      });
      logger.debug('✅ App Check initialized for development');
    } catch (error) {
      if (process.env.NODE_ENV === 'development') {
        logger.warn('⚠️ App Check initialization failed (this is normal for first-time setup):', error);
      }
    }
  } else if (isProduction) {
    // For production - use reCAPTCHA
    try {
      const _appCheck = initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider('6LcBAkcrAAAAAIQ69nUdnV96Aqq9y3Pjhg3oCl8i'),
        isTokenAutoRefreshEnabled: true
      });
      logger.debug('✅ App Check initialized for production');
    } catch (error) {
      // Silently handle App Check errors in production
      if (process.env.NODE_ENV === 'development') {
        logger.error('❌ App Check initialization failed in production:', error);
      }
    }
  } else {
    logger.debug('🔧 App Check disabled for this environment');
  }
}

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const googleProvider = new GoogleAuthProvider();

// Initialize Analytics (only in browser environment)
export const analytics = typeof window !== 'undefined' ? getAnalytics(app) : null;

// Export the app instance
export default app;
